export const volumes = [
  {
    number: 'I',
    title: 'The Oral Rehabilitation Case Assessment Blueprint™',
    subtitle: 'Organize the Case Before Building the Plan',
    intro: 'Before deciding how to approach a rehabilitation, you need a clear picture of the information available. I’ll show you how to organize the findings, records, observations, and unresolved questions that form the foundation of your case documentation.',
    bullets: [
      'The initial case overview',
      'Existing restorations and relevant clinical findings',
      'Functional and aesthetic observations',
      'Available photographs, records, and supporting information',
      'Areas requiring further evaluation',
      'Questions to resolve before finalizing the plan',
    ],
    outcome: 'A clear starting point instead of immediately jumping between treatment options.',
  },
  {
    number: 'II',
    title: 'Turn Clinical Findings Into Clear Treatment Objectives',
    subtitle: 'Stop Confusing What You Observe With What You Want to Achieve',
    intro: 'A clinical finding, a problem, and a treatment objective are related, but they aren’t the same thing. This volume helps you organize them separately so your planning becomes easier to follow and review.',
    bullets: [
      'Clinical findings and documented problems',
      'Proposed treatment objectives',
      'Functional and aesthetic considerations',
      'Restorative and prosthetic objectives',
      'Information that remains incomplete',
      'Questions requiring additional assessment',
    ],
    outcome: 'A structured problem-and-objective matrix you can revisit as the case develops.',
  },
  {
    number: 'III',
    title: 'Build Your Functional, Aesthetic & Prosthetic Planning Map',
    subtitle: 'See How the Different Parts of the Case Fit Together',
    intro: 'Complex oral rehabilitation often involves multiple considerations that must be evaluated in relation to one another. I’ll show you how to organize them in one visual framework.',
    bullets: [
      'Functional considerations and aesthetic objectives',
      'Restorative requirements and prosthetic considerations',
      'Existing restorations',
      'Dependencies between planned procedures',
      'Areas requiring interdisciplinary coordination',
      'Unresolved questions and documented constraints',
    ],
    outcome: 'Relationships between every part of your planning become easy to see and review.',
  },
  {
    number: 'IV',
    title: 'Put Your Rehabilitation Plan Into a Clear Sequence',
    subtitle: 'Organize the Proposed Phases Before Moving Forward',
    intro: 'A treatment plan isn’t simply a list of procedures. Order, available information at each stage, and dependencies all matter. This volume gives you a visual framework for documenting the proposed sequence.',
    bullets: [
      'The proposed treatment phases',
      'Dependencies between procedures',
      'Activities that may require coordination',
      'Points where additional information is needed',
      'Reassessment and review milestones',
      'Documentation of changes to the proposed plan',
    ],
    outcome: 'A roadmap you can review and update instead of keeping the sequence in your head.',
  },
  {
    number: 'V',
    title: 'The Rehabilitation Planning Review System™',
    subtitle: 'Review the Plan Before You Consider It Complete',
    intro: 'Some planning problems become visible only when the different parts of a case are reviewed together. That’s why I created a dedicated review framework.',
    bullets: [
      'Completeness of the available information',
      'Relationship between findings and objectives',
      'Functional, aesthetic, restorative and prosthetic requirements',
      'Dependencies between treatment phases',
      'Coordination and documentation requirements',
      'Follow-up and reassessment considerations',
    ],
    outcome: 'A reusable review checklist to document what’s been considered and what still needs attention.',
  },
  {
    number: 'VI',
    title: 'Turn Your Rehabilitation Plan Into a Complete Case Roadmap',
    subtitle: 'Bring Everything Together in One Visual Document',
    intro: 'In this final volume, I’ll show you how to create a structured case roadmap that brings the essential information into one place.',
    bullets: [
      'Case overview, findings, and documented problems',
      'Treatment objectives',
      'Functional, aesthetic, restorative and prosthetic requirements',
      'Proposed treatment phases',
      'Dependencies and outstanding questions',
      'Review milestones and follow-up documentation',
    ],
    outcome: 'A practical document you can revisit and update as new information becomes available.',
  },
];
